(function () {
    'use strict';

    angular.module('sempraWebapp').factory('voucherActions', voucherActionsFactory);

    /** @ngInject */
    function voucherActionsFactory(api, $q, $translate, dispatcher, ActionTypesEnum) {
        return {
            createLocalTokens: createLocalTokens,
            getVouchersHistory: getVouchersHistory,
            createVouchers: createVouchers,
            vouchersToCSV: vouchersToCSV,
            createAndRetrieveVouchers: createAndRetrieveVouchers,
            createAndRetrieveVouchersVacc: createAndRetrieveVouchersVacc,
            createAndRetrieveVouchersJetWash: createAndRetrieveVouchersJetWash
        };

        function createLocalTokens(email, amount) {
            var deferred = $q.defer();
            api.createLocalTokens(email, amount).then(function (data) {
                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('ISSUING_LOCAL_TOKENS_SUCCESS') + email
                    }
                });
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createAndRetrieveVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createAndRetrieveVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createAndRetrieveVouchersVacc(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createAndRetrieveVouchersVacc(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createAndRetrieveVouchersJetWash(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createAndRetrieveVouchersJetWash(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getVouchersHistory(page, pageSize, orderBy, order, seriesPrefix) {
            var deferred = $q.defer();
            api.getVouchersHistory(page, pageSize, orderBy, order, seriesPrefix).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function vouchersToCSV(seriesPrefix) {
            var deferred = $q.defer();
            api.vouchersToCSV(seriesPrefix).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }
    }
})();
